import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'auth/src/public_api';
import { AppGuard } from './app.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'explorer',
    pathMatch: 'full'
  },
  {
    path: 'explorer',
    canActivate: [AuthGuard, AppGuard],
    loadChildren: './explorer/explorer.module#ExplorerModule'
  },
  {
    path: 'settings',
    canActivate: [AuthGuard, AppGuard],
    loadChildren: './settings/settings.module#SettingsModule'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
